import {IntermediatePart} from "../../intermediatePart";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import store from "../../../../../store";
import {toggleNotCompatibleView} from "../../../../../actions/selectionFunctions";
import {PAN_POSITIONS, ShowerComboTubType} from "../../constants";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";

export default class ShowerFixture extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'shower_fixture';
    this.partName = 'Fixture';
    this.translateId = "visualizer.bathroom.shower.shower_fixture";
    this.homePageTitle = 'Shower Fixtures';
    this.dbName = 'Shower Fixture';
    this.layerPriority = 4;
    this.canBeDisabled = true;
    if (isChild) {
      this.layerPositions = {
        [PAN_POSITIONS[0]]: null,
        [PAN_POSITIONS[1]]: null,
        [PAN_POSITIONS[2]]: null,
      };
      // this.defaultLayerLayoutPositions = {
      //   [LayoutType.Layout1]: "L",
      //   [LayoutType.Layout4]: "C",
      // };
    }
  }

  load(dbFeature) {
    if (dbFeature.id === 79104774 || dbFeature.id === 79104772) { // Modern 4 & townsend disabled
      return false
    }
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    const partNumber = dbFeature.metaData["layerPosition"] === PAN_POSITIONS[0] ? 1 : 2;
    return super.load_(dbFeature, new ShowerFixture(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    const filteredAvailableFeatures2 = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters, this.featuresParts), searchText);
    let featuresToDisplay2 = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures2);
    featuresToDisplay2.forEach(feature2 => {
      if (featuresToDisplay.every(feature => feature.dbFeature.sharedFeatureName !== feature2.dbFeature.sharedFeatureName)) {
        featuresToDisplay.push(feature2)
      }
    })
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {

    const showerTubCombo = this.getParent().layout.parts[ShowerTubCombo.id];

    if (this.getParent().showerTubComboIsActive() && showerTubCombo && showerTubCombo.walkInTub
      && showerTubCombo.bottomTub === showerTubCombo.walkInTub.bottomTubId) {
      super.hideLayers();
      return;
    }
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  applyFeatureIfNotCompatible() {
    const parent = this.getParent();
    const shower = parent.getParent();
    if (shower.layout && shower.showerTubComboIsActive()
      && shower.layout.parts[ShowerTubCombo.id].bottomTub === ShowerComboTubType.walk_in_tub) {
      const comboPart = shower.layout.parts[ShowerTubCombo.id];
      comboPart.showerTubComboIsActive = false;
      comboPart.bottomTub = ShowerComboTubType.bathtub_liner;
    }
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked); // set active item & not in visualizer item
    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }

    const showerFixtureParent = this.getParent();
    const shower = showerFixtureParent.getParent();
    if (shower.showerTubComboIsActive() && shower.layout.parts[ShowerTubCombo.id].bottomTub === ShowerComboTubType.walk_in_tub
      && !window.location.hash.includes("visualizer")) {
      store.dispatch(toggleNotCompatibleView(true));
      return;
    }

    this.applyFeatureIfNotCompatible();
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerParent = this.getParent();
    conditions.push({
      propName: "Shower",
      propValue: showerParent.showerTubComboIsActive() ? "Tub" : "Shower"
    });
    conditions.push({
      propName: "ShowerSize",
      propValue: showerParent.showerSize()
    });
    return conditions
  }

  setZIndex(zIndexes) {
    if (zIndexes) {
      Object.keys(this.layerPositions).forEach((key, keyIndex) => {
        if (this.layerPositions[key]) {
          this.layerPositions[key].layer.zIndex = zIndexes.Shower.ShowerFixture + keyIndex*10;
        }
      })
    }
  }

}
